import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './AvatarIcon.css';
import Icon, { IconSizes, IconTypes, IconVariants } from '../foundations/Icon';

const AvatarIcon = ({
    children,
    iconName,
    iconSize = IconSizes.SMALL,
    iconType = IconTypes.MINGCUTE,
    iconVariant = IconVariants.LIGHT,
    className,
}) => (
    <div className={classNames(css.avatarIcon, className)}>
        {iconName ? <Icon name={iconName} size={iconSize} type={iconType} variant={iconVariant} /> : children}
    </div>
);

AvatarIcon.propTypes = {
    children: PropTypes.node.isRequired,
    iconName: PropTypes.string,
    iconSize: PropTypes.oneOf(Object.values(IconSizes)),
    iconType: PropTypes.oneOf(Object.values(IconTypes)),
    iconVariant: PropTypes.oneOf(Object.values(IconVariants)),
    className: PropTypes.string,
};

export default AvatarIcon;
